import { Pipe } from '@angular/core';
import { leftPad, isString } from '../utils/utils';
var LeftPadPipe = (function () {
    function LeftPadPipe() {
    }
    LeftPadPipe.prototype.transform = function (input, length, character) {
        if (length === void 0) { length = 0; }
        if (character === void 0) { character = ' '; }
        if (!isString(input)) {
            return input;
        }
        return leftPad(input, length, character);
    };
    return LeftPadPipe;
}());
export { LeftPadPipe };
LeftPadPipe.decorators = [
    { type: Pipe, args: [{
                name: 'leftpad'
            },] },
];
/** @nocollapse */
LeftPadPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=left-pad.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/left-pad.pipe.js
// module id = 280
// module chunks = 103